export default "__VITE_ASSET__CV0lk3k2__"